class ToggleDates {
  constructor() {
    this.moreButton = document.querySelector('.js--more-button');
    this.moreList = document.querySelector('.js--more-list');
    this.bindEvents();
  }

  bindEvents() {
    this.moreButton.addEventListener('click', this.toggle.bind(this));
  }

  toggle(e) {
    this.moreList.classList.toggle('more--is-open');
    if (this.moreList.classList.contains('more--is-open')) {
      this.moreButton.innerText = 'Less –';
      if (e.type === 'click') {
        document.activeElement.blur();
      }
    } else {
      this.moreButton.innerText = 'More Dates +';
      if (e.type === 'click') {
        document.activeElement.blur();
      }
    }
  }
}

export default ToggleDates;
